module.exports = __webpack_public_path__ + "erc_logo.png?4a9d642014f7b36ba9279f2066b6d4f6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erc_logo.png
// module id = 35
// module chunks = 0